import ProxyBase from '../../../../../../core/proxies/ProxyBase'

class HeaderInternationalProxy extends ProxyBase {
  getCountries(params) {
    return this.get('Countries', params)
  }

  getSearchHistory(params) {
    return this.get('SearchHistory', params)
  }

  postSearchHistory(params) {
    return this.post('SearchHistory', params)
  }

  deleteSearchHistory(params) {
    return this.delete('SearchHistory', params)
  }

  getCompany(params) {
    return this.get('Company', params)
  }
}

export default new HeaderInternationalProxy('InternationalSearch/')
